import React from 'react';
import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, isSameMonth, isSameDay, isToday } from 'date-fns';

const Calendar = ({ currentDate, events, keyTimes, onEventClick, onNewEvent }) => {
  // Get the start and end of the current month
  const monthStart = startOfMonth(currentDate);
  const monthEnd = endOfMonth(currentDate);
  
  // Get the start and end of the calendar view (Monday to Friday)
  const calendarStart = startOfWeek(monthStart, { weekStartsOn: 1 }); // Monday
  const calendarEnd = endOfWeek(monthEnd, { weekStartsOn: 1 }); // Friday

  // Generate calendar days (Monday to Friday only)
  const generateCalendarDays = () => {
    const days = [];
    let day = calendarStart;
    
    while (day <= calendarEnd) {
      // Only include Monday to Friday (1-5)
      const dayOfWeek = day.getDay();
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        days.push(day);
      }
      day = addDays(day, 1);
    }
    
    return days;
  };

  const calendarDays = generateCalendarDays();
  
  // Group days into weeks
  const weeks = [];
  for (let i = 0; i < calendarDays.length; i += 5) {
    weeks.push(calendarDays.slice(i, i + 5));
  }

  // Get events for a specific day
  const getEventsForDay = (day) => {
    return events.filter(event => 
      isSameDay(new Date(event.date), day)
    );
  };


  const dayNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  return (
    <div className="calendar-container">
      {/* Day Headers */}
      <div className="calendar-header">
        {dayNames.map(dayName => (
          <div key={dayName} className="day-header">
            {dayName}
          </div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div className="calendar-grid">
        {weeks.map((week, weekIndex) => (
          <React.Fragment key={weekIndex}>
            {week.map(day => {
              const dayEvents = getEventsForDay(day);
              const isCurrentMonth = isSameMonth(day, currentDate);
              const isTodayDate = isToday(day);
              
              return (
                <div
                  key={day.toISOString()}
                  className={`calendar-day ${!isCurrentMonth ? 'other-month' : ''} ${isTodayDate ? 'today' : ''}`}
                  onClick={() => onNewEvent(day)}
                >
                  <div className="day-number">
                    {format(day, 'd')}
                  </div>
                  
                  <div className="day-events">
                    {dayEvents.slice(0, 3).map(event => {
        // Determine class from event title
        let classCode = '';
        if (event.title) {
          const title = event.title.toLowerCase();
          if (title.includes('maths intervention')) {
            classCode = 'class-intervention';
          } else if (title.includes('7w/ma2')) {
            classCode = 'class-7w-ma2';
          } else if (title.includes('9w/ma2')) {
            classCode = 'class-9w-ma2';
          } else if (title.includes('9e/ma3b')) {
            classCode = 'class-9e-ma3b';
          } else if (title.includes('8e/ma1')) {
            classCode = 'class-8e-ma1';
          } else if (title.includes('8w/ma1')) {
            classCode = 'class-8w-ma1';
          }
        }
                      
                      return (
                        <div
                          key={event.id}
                          className={`event-item ${classCode} ${event.lesson_plan ? 'lesson' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            onEventClick(event);
                          }}
                          title={event.title}
                        >
                          {event.start_time && `${event.start_time.substring(0, 5)} `}
                          {event.title}
                        </div>
                      );
                    })}
                    {dayEvents.length > 3 && (
                      <div className="event-item">
                        +{dayEvents.length - 3} more
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>

      {/* Time Grid for Current Week */}
      <div className="time-grid">
        <div className="time-labels">
          {keyTimes.map(timeSlot => (
            <div key={timeSlot.id} className="time-label">
              {timeSlot.time}
            </div>
          ))}
        </div>
        
        <div className="time-slots">
          {keyTimes.map(timeSlot => (
            <div
              key={timeSlot.id}
              className="time-slot"
              onClick={() => onNewEvent(currentDate)}
              title={`${timeSlot.time} - ${timeSlot.label}`}
            >
              <div style={{ padding: '0.5rem', fontSize: '0.9rem' }}>
                {timeSlot.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
